declare global {
  interface Window {
    ANALYTICS_DEBUG: boolean;
  }
}

// @ts-ignore
import instrumentMethods from 'instrument-methods';

import { PREVIOUS_PAGE_APPLY } from 'src/modules/analytics';
import type { ReduxState } from 'src/types';

export const analyticsLogger = (methodName: string, args: any[]) => {
  if (window?.ANALYTICS_DEBUG) {
    // eslint-disable-next-line no-console
    console.log(`analytics.${methodName}()`, ...args);
  }
};

export const instrumentAnalytics = (analytics: any) =>
  instrumentMethods(analytics, { after: analyticsLogger });

export const applySuccessItemCheck = (
  getState: () => ReduxState,
  currentItemId: string,
) => {
  const {
    previousPage,
    queryStringRoute: { item: applySuccessItemId },
  } = getState().router;
  const isApplySuccessEdit =
    previousPage === PREVIOUS_PAGE_APPLY &&
    applySuccessItemId === currentItemId;

  return isApplySuccessEdit;
};
